import link from "@/scripts/host.js";

export default {
  name: "SearchResults",
  components: {},
  data() {
    return {
      numberOfDownloads: 10,
      resultsArray: null,
      infiniteId: +new Date(),

    };
  },
  methods: {
    infiniteHandler($state) {
      this.axios({
        method: "post",
        url: `${link.hostLink + this.category}`,
        data: { pageSize: 10, searchValue: this.query, skip: this.downloads }
      })
        .then(response => {
          if (response.data.data.length > 0) {
            this.resultsArray = [...this.resultsArray, ...response.data.data];
            this.numberOfDownloads += 10;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
    },
    getInitialList() {
      this.axios({
        method: "post",
        url: `${link.hostLink + this.category}`,
        data: { pageSize: 10, searchValue: this.query, skip: 0 }
        
      })
        .then(response => {
          this.resultsArray = response.data.data;
        })
    },
    goTo(name, id, query) {
      if (name.includes('Lista Przebojów Programu 3')) {
        this.$router.push(`/lp3/${query}`);
      } else if (name.includes('Polski Top Wszech Czasów')) {
        this.$router.push(`/polskitopwszechczasow/${query}`);
      } else if (name.includes('Top') && !name.includes('Polski Top')) {
        this.$router.push(`/topwszechczasow/${query}`);
      } else if (name.includes('Notowania specjalne')) {
        this.$router.push(`/topspecjalny/${id}`);
      }  else if (this.category.includes('Artist/Search')) {
        this.$router.push(`/artysta/${id}`);
      } else if (this.category.includes('Song/Search')) {
        this.$router.push(`/utwór/${id}`);
      } else if (this.category == "Artist") {
        if(!this.$route.path.includes(`artysta/${id}`)){
          this.$router.push(`/artysta/${id}`)
        }
      } else if (this.category == "Song") {
        if(!this.$route.path.includes(`utwór/${id}`)){
          this.$router.push(`/utwór/${id}`)
        }
      } 
    }

  },
  computed: {
    downloads() {
      return this.numberOfDownloads;
    },
    query() {
      return this.$store.state.searchQuery;
    },
    category() {
      return this.$store.state.searchCategory;
    }
  },
  mounted() {
    this.getInitialList();
  },
  watch: {
    query() {
      this.resultsArray = [];
      this.numberOfDownloads = 0;
      this.infiniteId += 1;
    },
    category() {
      this.resultsArray = [];
      this.numberOfDownloads = 0;
      this.infiniteId += 1;
    }
  }
};
